import { Box, Button, Typography } from "@mui/material";
import React, { Suspense } from "react";
import {
  getorderViewIdSelectedR,
  openVieweModalR,
} from "../../../General/Store/GeneralSlice";
import { useDispatch, useSelector } from "react-redux";
import { useDashboardModals } from "../../../Context/DashboardModalsContext";

function NotifcationItem({ item, seenMessage, theme }) {
  const dispatch = useDispatch();

  const { setOrderView } = useDashboardModals();
  const openViewOrder = () => {
    dispatch(getorderViewIdSelectedR({ id: item?.relatedId }));
    dispatch(openVieweModalR());
    setOrderView(true);
  };
  return (
    <Box
      component="li"
      sx={{
        display: "flex",
        flexDirection: "column",
        borderBottom: `1px solid ${theme === "dark" ? "#353841" : "#EDEDEF"}`,
        padding: "6px 0",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: theme === "dark" ? "#2c2f36" : "#f0f0f0",
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        padding={"0 0 6px 0"}
      >
        <span
          style={{
            color: "#4CAF50",
            fontSize: 12,
            background: theme==="dark"?  "#4CAF501A": "#F1F8F1",
            borderRadius: "12px",
            padding: "5px 8px",
          }}
        >
          {item.title}
        </span>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {item.type === 2 && (
            <Button
              sx={{
                color: "rgba(30, 106, 253, 1)",
                border: "1px solid rgba(30, 106, 253, 1)",
                margin: "0 8px",
                padding: "0 4px!important",
              }}
              onClick={() => {
                item.type === 2 ? openViewOrder() : null;
              }}
            >
              مشاهده
            </Button>
          )}
          <span style={{ fontSize: 12, color: "#D4164F" }}>{item.date}</span>
        </Box>
      </Box>

      <Typography
        fontWeight={300}
        component={"span"}
        fontSize={12}
        lineHeight={"1.5rem"}
        onClick={() => seenMessage(item.id)}
      >
        {item.description}
      </Typography>
    </Box>
  );
}

export default NotifcationItem;
